import { render, staticRenderFns } from "./HceVideo.vue?vue&type=template&id=127136aa&"
import script from "./HceVideo.vue?vue&type=script&lang=js&"
export * from "./HceVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports